import { useMemo } from 'react';

import { useLessonJoinHintsQuery } from 'core/graphql';
import { JoinClickHint, transformJoinClicks } from './transform';

type LessonJoinHintsType = {
  hints: JoinClickHint[];
  /** studentId → "HH:mm" of the join click. */
  joinTimeByStudentId: Record<string, string>;
  loading: boolean;
  error?: string;
};

/**
 * Spec 0013: teacher-only journal hints — which students clicked
 * "join lesson" and when.
 */
export const useLessonJoinHints = (groupLessonId: string, skip = false): LessonJoinHintsType => {
  const { data, loading, error } = useLessonJoinHintsQuery({
    variables: { groupLessonId: Number(groupLessonId) },
    skip: skip || !groupLessonId,
    fetchPolicy: 'cache-and-network',
  });

  const hints = useMemo(() => transformJoinClicks(data), [data]);

  const joinTimeByStudentId = useMemo(
    () =>
      hints.reduce(
        (times: Record<string, string>, hint) => ({ ...times, [hint.studentId]: hint.time }),
        {},
      ),
    [hints],
  );

  return { hints, joinTimeByStudentId, loading, error: error?.message };
};
